import { render, staticRenderFns } from "./feedbackInfo.vue?vue&type=template&id=151d89b7&scoped=true&"
import script from "./feedbackInfo.vue?vue&type=script&lang=js&"
export * from "./feedbackInfo.vue?vue&type=script&lang=js&"
import style0 from "./feedbackInfo.vue?vue&type=style&index=0&id=151d89b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d89b7",
  null
  
)

export default component.exports